import React, { FC } from 'react';
import { SocialNetwork } from 'types/socialNetwork';
import facebook from 'images/socialNetworkIcons/facebook.svg';
import instagram from 'images/socialNetworkIcons/instagram.svg';
import telegram from 'images/socialNetworkIcons/telegram.svg';
import youtube from 'images/socialNetworkIcons/youtube.svg';
import vk from 'images/socialNetworkIcons/vk.svg';
import twitter from 'images/socialNetworkIcons/twitter.svg';

import styled from 'styled-components';
import { SvgImage } from 'common/components/SvgImage';

const IconContainer = styled.div`
  width: 50px;
  height: 50px;
  display: flex;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: ${props => `2px solid ${props.color}`};
`;

const Icon = styled(SvgImage)`
  height: 30px;
  width: 30px;
`;

const getIconByName = (name: string): string => {
  switch (name) {
    case 'facebook':
      return facebook;
    case 'instagram':
      return instagram;
    case 'telegram':
      return telegram;
    case 'youtube':
      return youtube;
    case 'vk':
      return vk;
    case 'twitter':
      return twitter;
    default:
      return facebook;
  }
};

export const SocialNetworkIcon: FC<{
  network: SocialNetwork;
  color: string;
}> = ({ network, color }) => {
  return (
    <IconContainer color={color} onClick={() => open(network.url)}>
      <Icon color={color} source={getIconByName(network.icon)} />
    </IconContainer>
  );
};
